export type CatalogRouteQuery = {
  family?: string;
  view?: 'products' | 'categories' | 'maintenance';
  category?: string;
  ownership?: string;
  missingTaxonomy?: boolean;
  missingPrice?: boolean;
  active?: boolean;
  all?: boolean;
  q?: string;
};

export function encodeCatalogRouteQuery(c: CatalogRouteQuery): URLSearchParams {
  const params = new URLSearchParams();
  if (c.family !== undefined) params.set('family', c.family);
  if (c.view !== undefined) params.set('view', c.view);
  if (c.category !== undefined) params.set('category', c.category);
  if (c.ownership !== undefined) params.set('ownership', c.ownership);
  if (c.missingTaxonomy) params.set('missingTaxonomy', '1');
  if (c.missingPrice) params.set('missingPrice', '1');
  if (c.active === false) params.set('active', '0');
  if (c.active === true) params.set('active', '1');
  if (c.all) params.set('all', '1');
  if (c.q !== undefined) params.set('q', c.q);
  return params;
}

export function decodeCatalogRouteQuery(params: URLSearchParams): CatalogRouteQuery | undefined {
  const c: CatalogRouteQuery = {};
  if (params.has('family')) c.family = params.get('family')!;
  const view = params.get('view');
  if (view === 'products' || view === 'categories' || view === 'maintenance') c.view = view;
  if (params.has('category')) c.category = params.get('category')!;
  if (params.has('ownership')) c.ownership = params.get('ownership')!;
  if (params.get('missingTaxonomy') === '1') c.missingTaxonomy = true;
  if (params.get('missingPrice') === '1') c.missingPrice = true;
  if (params.get('active') === '0') c.active = false;
  if (params.get('active') === '1') c.active = true;
  if (params.get('all') === '1') c.all = true;
  if (params.has('q')) c.q = params.get('q')!;
  return Object.keys(c).length ? c : undefined;
}
